import React from 'react';
import {SITE_CONFIG} from '../config';

export const OPEN_PRIVACY_CHOICES_EVENT = 'treas:open-privacy-choices';

export default function PrivacyChoicesLink() {
  if (!SITE_CONFIG.ANALYTICS) return null;
  return (
    <button
      type="button"
      className="privacy-choices-inline"
      aria-haspopup="dialog"
      onClick={() => window.dispatchEvent(new Event(OPEN_PRIVACY_CHOICES_EVENT))}
    >
      Privacy choices
    </button>
  );
}
